import { get, post } from './httpClient'

export const apiUpdateEmployee = (object) => post('/user/adduser', object)
export const apiAllEmployee = () => get('/user')
export const apiFilterRoleEmployee = (object) => get('/user/getuser', object)
